export default __webpack_public_path__ + "static/media/heads-08.3cb4a609.svg";